import { render, staticRenderFns } from "./RemarksManagement.vue?vue&type=template&id=244cf148&scoped=true&"
import script from "./RemarksManagement.vue?vue&type=script&lang=js&"
export * from "./RemarksManagement.vue?vue&type=script&lang=js&"
import style0 from "./RemarksManagement.vue?vue&type=style&index=0&id=244cf148&scoped=true&lang=css&"
import style1 from "./RemarksManagement.vue?vue&type=style&index=1&id=244cf148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244cf148",
  null
  
)

export default component.exports